module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/vendor-contact/update-contact/update-contact.component.scss
// module id = ./src/app/pages/vendor/my-vendor/vendor-contact/update-contact/update-contact.component.scss
// module chunks = main